import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TeamsKeyType {
  addStatusTags: LocalesKey;
  addPerformer: LocalesKey;
  addUser: LocalesKey;
  addTerms: LocalesKey;
  addYourTeamMembersToCompany: LocalesKey;
  addEvent: LocalesKey;
  addFieldToGrid: LocalesKey;
  accountReceivables: LocalesKey;
  agreement: LocalesKey;
  artistsTeam: LocalesKey;
  airTable: LocalesKey;
  allCompanies: LocalesKey;
  allPerformers: LocalesKey;
  api: LocalesKey;
  automaticDebtRepayment: LocalesKey;
  automaticPaymentSC: LocalesKey;
  automaticContractorPayment: LocalesKey;
  autoCheckIn: LocalesKey;
  autoCheckInRule: LocalesKey;
  autoCheckInRules: LocalesKey;
  author: LocalesKey;
  basicInfo: LocalesKey;
  blockAccount: LocalesKey;
  blockedCompanies: LocalesKey;
  defaultView: LocalesKey;
  availableColumns: LocalesKey;
  availableColumnsDescription: LocalesKey;
  dragToReorder: LocalesKey;
  filterColumns: LocalesKey;
  newView: LocalesKey;
  predefinedFilters: LocalesKey;
  selectedColumns: LocalesKey;
  viewName: LocalesKey;
  changeEmail: LocalesKey;
  changeCompanyOwner: LocalesKey;
  changeCM: LocalesKey;
  removeAllCMs: LocalesKey;
  createCompany: LocalesKey;
  created: LocalesKey;
  createAndViewCompany: LocalesKey;
  companies: LocalesKey;
  companiesLowerCase: LocalesKey;
  selectedCompaniesLowerCase: LocalesKey;
  corevsharers: LocalesKey;
  clients: LocalesKey;
  clientTeam: LocalesKey;
  coefficient: LocalesKey;
  companyMembers: LocalesKey;
  companyHasNoOwner: LocalesKey;
  companyLibrary: LocalesKey;
  companyName: LocalesKey;
  companyUsers: LocalesKey;
  changeStatus: LocalesKey;
  changeMql: LocalesKey;
  changeSql: LocalesKey;
  changeSubcategory: LocalesKey;
  columnProperties: LocalesKey;
  columnType: LocalesKey;
  columnName: LocalesKey;
  customTab: LocalesKey;
  teamCustomTags: LocalesKey;
  enterColumnName: LocalesKey;
  enterOption: LocalesKey;
  addAnOption: LocalesKey;
  canViewAndEdit: LocalesKey;
  canView: LocalesKey;
  canEdit: LocalesKey;
  logChanges: LocalesKey;
  logChangesDescription: LocalesKey;
  onlyMe: LocalesKey;
  myTeam: LocalesKey;
  allWorkers: LocalesKey;
  fieldKey: LocalesKey;
  batchChange: LocalesKey;
  batchFieldUpdate: LocalesKey;
  cm: LocalesKey;
  dashboard: LocalesKey;
  documents: LocalesKey;
  debtLimit: LocalesKey;
  deferredPayment: LocalesKey;
  defaultTaskState: LocalesKey;
  description: LocalesKey;
  deliveryTime: LocalesKey;
  deleteTemplate: LocalesKey;
  downloadAllItems: LocalesKey;
  editCompanyPicture: LocalesKey;
  enterTheEmailAddressOfTheUser: LocalesKey;
  eventDispatcher: LocalesKey;
  eventName: LocalesKey;
  favorite: LocalesKey;
  financeInfo: LocalesKey;
  finance: {
    amr: LocalesKey;
    balance: LocalesKey;
    debt: LocalesKey;
    revenue: LocalesKey;
    sigmaPayments: LocalesKey;
    averagePaymentGap: LocalesKey;
    currentPaymentGap: LocalesKey;
    deferredPaymentDays: LocalesKey;
  };
  finLastPayments: LocalesKey;
  finStatus: LocalesKey;
  files: LocalesKey;
  followers: LocalesKey;
  goToProfile: LocalesKey;
  handler: LocalesKey;
  hourlyRate: LocalesKey;
  holdRate: LocalesKey;
  bookId: LocalesKey;
  info: LocalesKey;
  inviteNewUser: LocalesKey;
  integrations: LocalesKey;
  lastPayments: LocalesKey;
  lastActivity: LocalesKey;
  lastUpdate: LocalesKey;
  leadCreationDate: LocalesKey;
  firstPaymentDate: LocalesKey;
  list: LocalesKey;
  leaders: LocalesKey;
  londonDynamicsApi: LocalesKey;
  marketingData: LocalesKey;
  mql: LocalesKey;
  sql: LocalesKey;
  name: LocalesKey;
  noCompanies: LocalesKey;
  ownerId: LocalesKey;
  payoutStatus: LocalesKey;
  paymentsStatus: LocalesKey;
  paymentsStatusTags: LocalesKey;
  performer: LocalesKey;
  performers: LocalesKey;
  performersTat: LocalesKey;
  performersTeam: LocalesKey;
  plural: LocalesKey;
  pluralLowerCase: LocalesKey;
  pm: LocalesKey;
  profile: LocalesKey;
  provideAccess: LocalesKey;
  provisionForBadDebt: LocalesKey;
  provisionForRevision: LocalesKey;
  permissions: LocalesKey;
  personalization: LocalesKey;
  plannedDate: LocalesKey;
  recentCompanies: LocalesKey;
  recalculateBalances: LocalesKey;
  records: LocalesKey;
  reports: LocalesKey;
  respondTime: LocalesKey;
  requirements: LocalesKey;
  resume: LocalesKey;
  restoreEvent: LocalesKey;
  revenueShare: LocalesKey;
  revisions: LocalesKey;
  singular: LocalesKey;
  source: LocalesKey;
  status: LocalesKey;
  statusTag: LocalesKey;
  statusPlural: LocalesKey;
  searchCompanies: LocalesKey;
  searchPerformers: LocalesKey;
  selectCompany: LocalesKey;
  selectCompanies: LocalesKey;
  selectCompanyWithoutEllipsis: LocalesKey;
  selectEvent: LocalesKey;
  settings: LocalesKey;
  sendInvitations: LocalesKey;
  shares: LocalesKey;
  smartContractSettings: LocalesKey;
  statuses: {
    new: LocalesKey;
    active: LocalesKey;
    paused: LocalesKey;
    declined: LocalesKey;
    realDecline: LocalesKey;
    noPayments: LocalesKey;
    pbd: LocalesKey;
    churn: LocalesKey;
    reconnect: LocalesKey;
  };
  subbooks: LocalesKey;
  suspendEvent: LocalesKey;
  scTemplates: LocalesKey;
  tasksWithoutSourceFiles: LocalesKey;
  tat: LocalesKey;
  terms: LocalesKey;
  transactionFee: LocalesKey;
  trigger: LocalesKey;
  totalPayments: LocalesKey;
  thisMonthPayments: LocalesKey;
  viewPerTask: LocalesKey;
  vendorForm: LocalesKey;
  walmartMyLibraryFilters: LocalesKey;
  billingInfo: LocalesKey;
  items: LocalesKey;
  wire: LocalesKey;
  card: LocalesKey;
  preferredPaymentMethod: LocalesKey;
  addBillingInfoToSetPaymentMethod: LocalesKey;
  pleaseSelectBillingInfo: LocalesKey;
  merge: LocalesKey;
  mergeCompany: LocalesKey;
  mergeCompaniesWarning: {
    caution: LocalesKey;
    allUserInformationFromTheSelected: LocalesKey;
    company: LocalesKey;
    willBe: LocalesKey;
    merged: LocalesKey;
  };
  myCompanies: LocalesKey;
  myPerformers: LocalesKey;
  selectUser: LocalesKey;
  uploadInvoices: LocalesKey;
  usersInvited: LocalesKey;
  cantChangeSubcategoryMessage: LocalesKey;
  stateOnlyAvailableForUsaCountry: LocalesKey;
  stateOnlyForUsaCompanies: LocalesKey;
}

export const teamsKeys = keyPathMirror<TeamsKeyType, string>(
  {
    addStatusTags: null,
    addPerformer: null,
    addUser: null,
    addTerms: null,
    addYourTeamMembersToCompany: null,
    addEvent: null,
    addFieldToGrid: null,
    accountReceivables: null,
    agreement: null,
    artistsTeam: null,
    airTable: null,
    allCompanies: null,
    allPerformers: null,
    api: null,
    automaticDebtRepayment: null,
    automaticPaymentSC: null,
    automaticContractorPayment: null,
    autoCheckIn: null,
    autoCheckInRule: null,
    autoCheckInRules: null,
    author: null,
    basicInfo: null,
    blockAccount: null,
    blockedCompanies: null,
    defaultView: null,
    availableColumns: null,
    availableColumnsDescription: null,
    dragToReorder: null,
    filterColumns: null,
    newView: null,
    predefinedFilters: null,
    selectedColumns: null,
    viewName: null,
    changeEmail: null,
    changeCompanyOwner: null,
    changeCM: null,
    removeAllCMs: null,
    createCompany: null,
    created: null,
    createAndViewCompany: null,
    companies: null,
    companiesLowerCase: null,
    selectedCompaniesLowerCase: null,
    corevsharers: null,
    clients: null,
    clientTeam: null,
    coefficient: null,
    companyMembers: null,
    companyHasNoOwner: null,
    companyLibrary: null,
    companyName: null,
    companyUsers: null,
    changeStatus: null,
    changeMql: null,
    changeSql: null,
    changeSubcategory: null,
    columnProperties: null,
    columnType: null,
    columnName: null,
    customTab: null,
    teamCustomTags: null,
    enterColumnName: null,
    enterOption: null,
    addAnOption: null,
    canViewAndEdit: null,
    canView: null,
    canEdit: null,
    logChanges: null,
    logChangesDescription: null,
    onlyMe: null,
    myTeam: null,
    allWorkers: null,
    fieldKey: null,
    batchChange: null,
    batchFieldUpdate: null,
    cm: null,
    dashboard: null,
    documents: null,
    debtLimit: null,
    deferredPayment: null,
    defaultTaskState: null,
    description: null,
    deliveryTime: null,
    deleteTemplate: null,
    downloadAllItems: null,
    editCompanyPicture: null,
    enterTheEmailAddressOfTheUser: null,
    eventDispatcher: null,
    eventName: null,
    favorite: null,
    financeInfo: null,
    finance: {
      amr: null,
      balance: null,
      debt: null,
      revenue: null,
      sigmaPayments: null,
      averagePaymentGap: null,
      currentPaymentGap: null,
      deferredPaymentDays: null
    },
    finLastPayments: null,
    finStatus: null,
    files: null,
    followers: null,
    goToProfile: null,
    handler: null,
    hourlyRate: null,
    holdRate: null,
    bookId: null,
    info: null,
    inviteNewUser: null,
    integrations: null,
    lastPayments: null,
    lastActivity: null,
    lastUpdate: null,
    leadCreationDate: null,
    firstPaymentDate: null,
    list: null,
    leaders: null,
    londonDynamicsApi: null,
    marketingData: null,
    mql: null,
    sql: null,
    name: null,
    noCompanies: null,
    ownerId: null,
    payoutStatus: null,
    paymentsStatus: null,
    paymentsStatusTags: null,
    performer: null,
    performers: null,
    performersTat: null,
    performersTeam: null,
    plural: null,
    pluralLowerCase: null,
    pm: null,
    profile: null,
    provideAccess: null,
    provisionForBadDebt: null,
    provisionForRevision: null,
    permissions: null,
    personalization: null,
    plannedDate: null,
    recentCompanies: null,
    recalculateBalances: null,
    records: null,
    reports: null,
    respondTime: null,
    requirements: null,
    resume: null,
    restoreEvent: null,
    revenueShare: null,
    revisions: null,
    singular: null,
    source: null,
    status: null,
    statusTag: null,
    statusPlural: null,
    searchCompanies: null,
    searchPerformers: null,
    selectCompany: null,
    selectCompanies: null,
    selectCompanyWithoutEllipsis: null,
    selectEvent: null,
    settings: null,
    sendInvitations: null,
    shares: null,
    smartContractSettings: null,
    statuses: {
      new: null,
      active: null,
      paused: null,
      declined: null,
      realDecline: null,
      noPayments: null,
      pbd: null,
      churn: null,
      reconnect: null
    },
    subbooks: null,
    suspendEvent: null,
    scTemplates: null,
    tasksWithoutSourceFiles: null,
    tat: null,
    terms: null,
    transactionFee: null,
    trigger: null,
    totalPayments: null,
    thisMonthPayments: null,
    viewPerTask: null,
    vendorForm: null,
    walmartMyLibraryFilters: null,
    billingInfo: null,
    items: null,
    wire: null,
    card: null,
    preferredPaymentMethod: null,
    addBillingInfoToSetPaymentMethod: null,
    pleaseSelectBillingInfo: null,
    merge: null,
    mergeCompany: null,
    mergeCompaniesWarning: {
      caution: null,
      allUserInformationFromTheSelected: null,
      company: null,
      willBe: null,
      merged: null
    },
    myCompanies: null,
    myPerformers: null,
    selectUser: null,
    uploadInvoices: null,
    usersInvited: null,
    cantChangeSubcategoryMessage: null,
    stateOnlyAvailableForUsaCountry: null,
    stateOnlyForUsaCompanies: null
  },
  'models.teams.'
);
